var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0 pt-0",attrs:{"input-value":_vm.value,"dense":"","hide-details":"","color":"primary","label":"تضمين التصنيفات المحذوفة في قائمة البحث"},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }